export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11456.f0891bc2.jpg";